var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","z-index":"1"}},[_c('div',{staticClass:"box-emprty"},[_c('div',{staticClass:"emptyBox"})])])
}]

export { render, staticRenderFns }